// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"3":"f23eda73","20":"3fd56de1","142":"1d27e90d","542":"129440a0","828":"9b95b4dd"}[chunkId] + ".css";
};